export * from './competition-category';
export * from './competition-details';
export * from './competition';
export * from './competition-flight-status';
export * from './competition-flight';
export * from './competition-list';
export * from './competition-payment';
export * from './competition-player';
export * from './competition-prize';
export * from './competition-sponsor';
export * from './leaderboard-player';
export * from './leaderboard';
export * from './hole-score';
export * from './which-nine';
export * from './competition-game-round';
export * from './team-player';
export * from './team';
export * from './competition-teams';


// WEBPACK FOOTER //
// D:/bs_work/toMigrate_litePortal/src/app/models/mygolf/competition/index.ts